<template>
  <Form
    v-model="modelFormData"
    ref="Form"
    class="form"
    :class="[isEdit ? 'form--bg' : '']"
    :clear-on-destroy="clearOnDestroy"
    @clear="clear"
    @request="onSubmit"
  >
    <div class="form__inputs">
      <slot />
    </div>

    <FormButtonGroup
      :is-edit="isEdit"
      :is-sending="isSending"
      @cancel="onCancel"
    />
  </Form>
</template>

<script>
import Form from '@/components/page/Form/Form.vue'
import FormButtonGroup from '@/components/page/Form/FormButtonGroup'

import { MIXIN_FORM } from '@/mixins/form/mixinForm'

export default {
  components: {
    FormButtonGroup,
    Form
  },

  mixins: [MIXIN_FORM]
}
</script>
